import { jsx as _jsx } from "react/jsx-runtime";
import cn from 'classnames';
import ErrorIcon from '@material-ui/icons/Error';
import Icon from '../Icon';
import withStyles from '../withStyles';
import styles from './AlertIcon.styles';
export const AlertIcon = ({ color = 'error', classes, className, }) => {
    if (color === 'error') {
        return _jsx(ErrorIcon, { className: cn(classes.icon, classes.error, className) });
    }
    if (color === 'warning') {
        return (_jsx(ErrorIcon, { className: cn(classes.icon, classes.warning, className) }));
    }
    return (_jsx(Icon, { icon: "alert", className: cn(classes.icon, classes.default, className) }));
};
export default withStyles(styles)(AlertIcon);
//# sourceMappingURL=AlertIcon.js.map